import { render, staticRenderFns } from "./RecursionSubMenu.vue?vue&type=template&id=2c09c4e3&functional=true&"
import script from "./RecursionSubMenu.vue?vue&type=script&lang=js&"
export * from "./RecursionSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports